import { inject } from '@angular/core';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

let isRefreshing = false;
let pendingRequests: (() => void)[] = [];

export const authInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const auth = inject(AuthService);

  const token = auth.getAccessToken();
  const cloned = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;
  return next(cloned).pipe(
    catchError(err => {
      if (err.status === 401) {
        if (!isRefreshing) {
          isRefreshing = true;
          return from(auth.sendRefreshToken()).pipe(
            switchMap(newToken => {
              isRefreshing = false;
              const requests = [...pendingRequests];
              pendingRequests = [];
              requests.forEach(fn => fn());
              const retryReq = req.clone({ setHeaders: { Authorization: `Bearer ${newToken}` } });
              return next(retryReq);
            }),
            catchError(refreshErr => {
              isRefreshing = false;
              pendingRequests = [];
              auth.logout();
              window.location.href = '/';
              return throwError(() => refreshErr);
            })
          );
        } else {
          return new Observable<HttpEvent<unknown>>(subscriber => {
            pendingRequests.push(() => {
              const retryReq = req.clone({ setHeaders: { Authorization: `Bearer ${auth.getAccessToken()}` } });
              next(retryReq).subscribe(subscriber);
            });
          });
        }
      }
      return throwError(() => err);
    })
  );
};
